import * as React from "react";
import styled, { css } from "styled-components";
import { useTranslation } from "react-i18next";
import { Button } from "components/bootstrap";
import useIsInvestigationAIReportEnabled from "security-app/components/Investigations/AIReport/hooks/useIsInvestigationAIReportEnabled";
import AIReportButton from "security-app/components/Investigations/AIReport/AIReportButton";
import InvestigationMoreActionsMenu from "./InvestigationMoreActionsMenu";
import useInvestigationPanel from "./hooks/useInvestigationPanel";
const Wrapper = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: ${theme.spacings.xs};
  `
);
function RowActionMenu({
  investigation,
  onDelete: onDeleteProp = void 0,
  onArchive: onArchiveProp = void 0,
  onRestore: onRestoreProp = void 0
}) {
  var _a, _b;
  const { t } = useTranslation("enterprise_security_investigations");
  const isAIReportFeatureEnabled = useIsInvestigationAIReportEnabled();
  const { selectedInvestigationId, setSelectedInvestigationId } = useInvestigationPanel();
  return /* @__PURE__ */ React.createElement(Wrapper, null, isAIReportFeatureEnabled && /* @__PURE__ */ React.createElement(
    AIReportButton,
    {
      investigation,
      bsSize: "xsmall",
      logsCount: (_a = investigation == null ? void 0 : investigation.evidence_counts) == null ? void 0 : _a.logs,
      eventsCount: (_b = investigation == null ? void 0 : investigation.evidence_counts) == null ? void 0 : _b.events
    }
  ), !investigation.archived && investigation.id !== selectedInvestigationId && /* @__PURE__ */ React.createElement(
    Button,
    {
      bsSize: "xsmall",
      onClick: () => setSelectedInvestigationId(investigation.id, true),
      title: t("row_action_menu.set_active_title", { name: investigation.name })
    },
    t("row_action_menu.set_active")
  ), /* @__PURE__ */ React.createElement(
    InvestigationMoreActionsMenu,
    {
      investigation,
      isArchived: investigation.archived,
      asTableRowAction: true,
      onDelete: onDeleteProp,
      onArchive: onArchiveProp,
      onRestore: onRestoreProp
    }
  ));
}
export default RowActionMenu;
